import React, { useState } from "react";
import Pill from "../common/Pill";

const testimonials = [
  {
    id: 1,
    name: "Jake K.",
    role: "Restaurant Owner",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    rating: 5,
    text: `Training a waiter takes so much time and even after training their customer service is inconsistent. Having a Voice AI Agent be on every table to answer questions about the menu, the restuarant, or any other relevant questions is a huge improvement in my restaurant operations. I see this driving huge productivity gains for my waiting staff and make me better able to deliver steller, consistent customer service during peak traffic.`,
  },
  {
    id: 2,
    name: "Samantha L.",
    role: "Event Director",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    rating: 4,
    text: `The days of having long pages of FAQs on event websites are over; with AgoraVoice, we only provide the knowledge base once and Voice AI delivers instant, precise answers to thousands of questions about logistics, ticketing, and operations -- questions that would often get lost in a sea of text on a screen. It has completely streamlined our about to disseminate information by replacing clunky websites with a more modern, direct, and conversational format. We’re able to provide a premium attendee experience where the barrier between a question and an answer has been entirely removed. `,
  },
  {
    id: 3,
    name: "Carlos M.",
    role: "Gym Owner",
    avatar: "https://randomuser.me/api/portraits/men/54.jpg",
    rating: 5,
    text: `AgoraVoice is a game-changer for gyms everywhere. Members can quickly get answers to common questions about classes, schedules, membership, and equipment. I only have to provide the information once in AgoraVoice portal and the agent knows more about our gym than any of our staff. It’s like having an superstar staff member who never gets tired!`,
  },
];

export const StarRating = ({ rating }) => {
  return (
    <div className="hidden sm:flex space-x-1">
      {[...Array(5)].map((_, i) => (
        <svg
          key={i}
          className={`w-5 h-5 ${i < rating ? "text-yellow-400" : "text-gray-400"
            }`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.962a1 1 0 00.95.69h4.176c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.287 3.963c.3.922-.755 1.688-1.54 1.118L10 13.347l-3.38 2.455c-.784.57-1.838-.196-1.539-1.118l1.287-3.963a1 1 0 00-.364-1.118L3.624 9.39c-.783-.57-.38-1.81.588-1.81h4.176a1 1 0 00.95-.69l1.286-3.962z" />
        </svg>
      ))}
    </div>
  );
};

export default function Testimonial() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentTestimonial = testimonials[currentIndex];

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className="bg-gradient-to-b from-[#1C1C1C] to-[#320606] text-white   py-16 sm:py-20 ">
      <div className="flex flex-col items-center text-center gap-2 max-w-6xl mx-auto px-4 md:px-8">
        <Pill text="Testimonial" backgroundColor="#FFFFFF1A" />
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-2 text-center text-white">
          Trusted Across Every Industry
        </h2>
        <p className="mt-2 text-sm text-[#E1E1E1] max-w-xl mx-auto">
          AgoraVoice can help all businesses to evolve the way they interact with customers and 
          enhance the customer experience using AI voice assistants.
        </p>
        <div className="mt-10 sm:mt-14 relative bg-white/5 rounded-2xl p-4  max-w-6xl mx-auto">
          <div className="bg-white/5 rounded-2xl p-4 sm:p-8 relative">
            <div className="absolute top-4 right-4 sm:top-6 sm:right-6">
              <StarRating rating={currentTestimonial.rating} />
            </div>

            <div className="flex items-center space-x-4 mb-4">
              <img
                src={currentTestimonial.avatar}
                alt={currentTestimonial.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <p className="font-semibold">{currentTestimonial.name}</p>
                <p className="text-xs text-zinc-500">{currentTestimonial.role}</p>
              </div>
            </div>

            <p className="text-sm leading-relaxed">{currentTestimonial.text}</p>

            <div className="flex justify-center items-center mt-6 sm:mt-8">
              <div className="flex space-x-2 items-center">
                {testimonials.map((_, idx) => (
                  <button
                    key={idx}
                    className={`w-[6px] h-[6px] rounded-full transition ${idx === currentIndex ? "border border-red-500 p-2" : "bg-white"
                      }`}
                    aria-label={`Go to testimonial ${idx + 1}`}
                    onClick={() => setCurrentIndex(idx)}
                  />
                ))}
              </div>
            </div>

            {/* Fixed arrows (hidden on mobile) */}
            <button
              onClick={handlePrev}
              aria-label="Previous testimonial"
              className="hidden sm:flex absolute left-[-45px] top-1/2 -translate-y-1/2 bg-zinc-200 bg-opacity-80 text-red-500 rounded-full p-2 hover:bg-opacity-100 transition"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            <button
              onClick={handleNext}
              aria-label="Next testimonial"
              className="hidden sm:flex absolute right-[-45px] top-1/2 -translate-y-1/2 bg-zinc-200 bg-opacity-80 text-red-500 rounded-full p-2 hover:bg-opacity-100 transition"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>


    </section>
  );
}
